import React from 'react'
import isEqual from 'lodash/isEqual'
import { List } from 'immutable'
import SelectList from 'components/common/SelectList'
import { formatMessage } from 'lib/intl'
import { ALL_SELECTED, EMPTY } from 'constants/index'
import { getExistedValue } from '../Common/utils'

function AssigneesFilter({
  assigneesList,
  assignees,
  setAssignees,
  saveFilter,
}) {
  const value =
    assigneesList && assigneesList.length
      ? getExistedValue(assignees, assigneesList)
      : []
  const getAllSelected = () =>
    assigneesList && assigneesList.map(item => item.id)
  const handleAssigneesChange = value => {
    let selected

    if (value === ALL_SELECTED) {
      selected = getAllSelected()
    } else if (value === EMPTY) {
      selected = []
    } else {
      selected = value.map(item => item && item.index)
    }

    if (!isEqual(selected, assignees)) {
      const filteredSelected = selected.filter(item => !!item)
      setAssignees(filteredSelected)
      saveFilter({ assignees: filteredSelected })
    }
  }

  return (
    <SelectList
      multiple
      withCheckBox
      hasAllValueOption
      outMultipleValues={{
        all: ALL_SELECTED,
        empty: EMPTY,
      }}
      name="creators"
      label={formatMessage('assignees')}
      list={List(assigneesList)}
      value={value}
      onClose={handleAssigneesChange}
      map={{
        index: 'id',
        text: 'name',
      }}
    />
  )
}

export default AssigneesFilter
